/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FixCredential {
  id?: number;
  active?: boolean;
  compId?: string;
  comment?: string;
  accountId?: number;
  username?: string;
  talos?: boolean;
}
